<template>
  <router-view />
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;1,100;1,200;1,300;1,400&display=swap');

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1rem;
  line-height: 1.5;
  text-align: left;
  color: rgb(70, 90, 110, 0.85);
  background-color: #d6dadd;
}

#app {
  font-family: Poppins, Arial, Helvetica, sans-serif;
}

.regular-alert > .swal-title {
  font-size: 20px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 1px 1px #dddddd;
}

.regular-alert > .swal-title:first-child {
  margin-top: 10px;
}

.regular-alert > .swal-text {
  margin-top: 25px;
}

.regular-alert > .swal-footer {
  background-color: white;
  margin-top: 50px;
  border-top: 1px solid #dddddd;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}

body::after {
  content: '';
  background-image: url('../src/assets/img/bg1.svg');
  background-repeat: no-repeat;
  height: 100vh;
  width: 100vw;
  position: absolute;
  z-index: -1000;
  top: 0;
  background-size: cover;
  opacity: 0.35;
  will-change: filter;
  filter: grayscale(90%);
}
</style>
